import React from 'react';
import styled from 'styled-components';

const StyledInfoIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  width: 18px;
  min-width: 18px;
  height: 18px;
  margin-left: 7px;
  border-radius: 9px;
  text-align: center;
  font-family: initial;
  font-weight: 600;
  outline: none;
  &:after {
    content: 'i';
    font-size: 14px;
    line-height: 20px;
  }
  [dir='rtl'] & {
    margin-right: 7px;
    margin-left: unset;
  }
`;

const InfoIconRC: React.FunctionComponent = () => (
  <StyledInfoIcon
    className="rc-info-icon"
  />
);

export default InfoIconRC;
